import { SleepSettingPureType } from '@shared/api/graphql/generated';

class SleepSettingsUtils {
  static getSleepSettings = (
    fromTime: string,
    toTime: string,
    sleepSettings?: SleepSettingPureType[],
    isDifferentTime?: boolean
  ) => {
    if (!isDifferentTime) {
      return [
        {
          day: 1,
          start: fromTime,
          end: toTime,
        },
        {
          day: 2,
          start: fromTime,
          end: toTime,
        },
        {
          day: 3,
          start: fromTime,
          end: toTime,
        },
        {
          day: 4,
          start: fromTime,
          end: toTime,
        },
        {
          day: 5,
          start: fromTime,
          end: toTime,
        },
        {
          day: 6,
          start: fromTime,
          end: toTime,
        },
        {
          day: 7,
          start: fromTime,
          end: toTime,
        },
      ];
    }

    return sleepSettings;
  };

  static getTimeFormat = (timeString: string) => {
    const timeParts = timeString.split(':');
    return `${timeParts[0]}:${timeParts[1]}`;
  };
}

export default SleepSettingsUtils;
